import { Pipe, PipeTransform } from '@angular/core';
import { stripHtml } from '@fui/fui-helpers';

@Pipe({
    name: 'stripHtml',
    standalone: true,
})
export class StripHtmlPipe implements PipeTransform {
    transform(value: any): any {
        return stripHtml(value);
    }
}
